<template>
    <b-modal
        ref="modalManageKeys"
        lazy
        title-tag="h2"
        :title="title"
        ok-title="Save"
        footer-class="d-flex"
        no-close-on-backdrop
        no-close-on-esc
    >
        <b-form-group label-for="title" label-cols="3" label="Merchant ID:">
            <b-input
                v-model="merchantId"
                name="merchantId"
                autofocus
                type="text"
                placeholder="Merchant ID (required)"
                :disabled="isLoading"
                v-validate="'required'"
                :class="{
                    'border-danger': errors.has('merchantId')
                }"
            />
        </b-form-group>

        <template v-slot:modal-footer="{ close }">
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="proceed">
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";
import Payment from "@/services/payment";
import EXTENSIONS from "@/constants/extensions";

export default {
    components: {
        Loader
    },
    data: function () {
        return {
            title: "Manage Keys",
            merchantId: "",
            isLoading: false
        };
    },
    watch: {},
    mounted: function () {},
    methods: {
        async open() {
            await this.getCurrentPaymentAcc();
            this.$refs.modalManageKeys.show();
        },
        async proceed() {
            // saving process
            try {
                let valid = await this.$validator.validateAll();
                if (!valid) {
                    return false;
                }
                let formData = new FormData();
                this.isLoading = true;

                formData.append("merchant_id", this.merchantId);
                const res = await Payment.saveManageKeys(formData);

                if (res.state == 0) {
                    this._message(res.message, "success");
                    this.$refs.modalManageKeys.hide();
                    location.reload();
                } else {
                    throw new Error(res.message);
                }
            } catch (error) {
                this.isLoading = false;
                this.errorMessage = error.message;
            }
        },
        async getCurrentPaymentAcc() {
            Payment.getPaymentAccounts(this._setting.business.id)
                .then(response => {
                    if (
                        response.message.code == 200 &&
                        response.message.payment_processor_id
                    ) {
                        let text =
                            response.message.processor ==
                            EXTENSIONS.CODE.CODE_CCONNECT
                                ? "Card Connect"
                                : "STRIPE";
                        this.title = this.title + " (" + text + ")";
                        this.merchantId = response.message.payment_processor_id;
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
};
</script>

<style scoped></style>
